import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "account_balance", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_AlertInfo = _resolveComponent("AlertInfo")!
  const _component_base_tab_link = _resolveComponent("base-tab-link")!
  const _component_LibContentBlocks = _resolveComponent("LibContentBlocks")!
  const _component_base_tab_pane = _resolveComponent("base-tab-pane")!
  const _component_base_tab = _resolveComponent("base-tab")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.contentLibraryAvailableUI.isReady() && this.hasContentBlockLibsForType)
      ? (_openBlock(), _createBlock(_component_base_modal_button, {
          key: 0,
          class: _normalizeClass('btn btn-hover icon-link ' + this.class),
          "modal-id": this.modalId
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(_toDisplayString(_ctx.$t('copyFromLibrary')), 1)
          ]),
          _: 1
        }, 8, ["class", "modal-id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_base_modal, {
      "modal-id": this.modalId,
      "dialog-classes": "modal-xl modal-dialog-scrollable",
      title: this.title
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AlertError2, {
          error: this.contentLibraryAvailableUI.getError()
        }, null, 8, ["error"]),
        _createVNode(_component_AlertInfo, {
          description: _ctx.$t('descriptionLibraries'),
          class: "mb-3"
        }, null, 8, ["description"]),
        (this.contentLibraryAvailableUI.isReady())
          ? (_openBlock(), _createBlock(_component_base_tab, {
              key: 0,
              "tab-id": "nav-tab"
            }, {
              tabs: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.contentBlockLibsForType, (contentBlockLibForType, i) => {
                  return (_openBlock(), _createBlock(_component_base_tab_link, {
                    key: contentBlockLibForType.library.code,
                    target: contentBlockLibForType.library.code,
                    title: contentBlockLibForType.library.description ?? _ctx.$t('title'),
                    "is-active": i === 0
                  }, null, 8, ["target", "title", "is-active"]))
                }), 128))
              ]),
              content: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.contentBlockLibsForType, (contentBlockLibForType, i) => {
                  return (_openBlock(), _createBlock(_component_base_tab_pane, {
                    key: contentBlockLibForType.library.code,
                    id: contentBlockLibForType.library.code,
                    "is-active": i === 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LibContentBlocks, {
                        "cb-type": this.cbType,
                        library: contentBlockLibForType.library,
                        "src-lib-code": this.srcLibCode,
                        onCopied: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('copied'))),
                        onExceptions: this.setExceptions
                      }, null, 8, ["cb-type", "library", "src-lib-code", "onExceptions"])
                    ]),
                    _: 2
                  }, 1032, ["id", "is-active"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ], 64))
}